/**
 * Phase 36da.99.mv — Material Variant master client.
 */
import API from "./axios";

const materialVariantApi = {
  getAll:        ()           => API.get("/material-variant"),
  getActive:     ()           => API.get("/material-variant/active"),
  getByMaterial: (materialId) => API.get(`/material-variant/by-material/${materialId}`),
  getById:       (id)         => API.get(`/material-variant/${id}`),
  create:        (data)       => API.post("/material-variant", data),
  update:        (id, data)   => API.put(`/material-variant/${id}`, data),
  toggleStatus:  (id)         => API.patch(`/material-variant/${id}/toggle-status`),
  delete:        (id)         => API.delete(`/material-variant/${id}`),
};

export default materialVariantApi;